import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'

import { AuthConfig } from 'angular-oauth2-oidc'

import { Observable, of } from 'rxjs'

import { AuthConfigService } from './auth.service'

@Injectable()
export class AuthGuardWithForcedLogin {
  private authService = inject(AuthConfigService)
  private authConfig = inject(AuthConfig)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // Check authentication status
    // OAuth callbacks are now processed by appInitializer() before guards run
    const hasValidToken = this.authService.hasValidToken()

    if (!hasValidToken) {
      this.authService.login(state.url, route.queryParams)
      return of(false)
    }

    // User is authenticated - allow navigation
    return of(true)
  }
}
